import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

// Clientseitiges Rendering
const rootElement = document.getElementById('root');

if (rootElement) {
  // Prüfen, ob die Seite bereits serverseitig gerendert wurde
  const hasSSRContent = rootElement.innerHTML.trim().length > 0;

  if (hasSSRContent) {
    // Hydrate den vorgerenderten Inhalt, anstatt ihn zu ersetzen
    import('react-dom/client').then(({ hydrateRoot }) => {
      hydrateRoot(
        rootElement,
        <React.StrictMode>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </React.StrictMode>
      );
    });
  } else {
    // Normales clientseitiges Rendering, wenn kein SSR-Inhalt vorhanden ist
    import('react-dom/client').then(({ createRoot }) => {
      createRoot(rootElement).render(
        <React.StrictMode>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </React.StrictMode>
      );
    });
  }
}
